import {
  SCOUTING_VERTICAL_SECTOR,
  SCOUTING_TARGET_AUDIENCE,
  SCOUTING_BUSINESS_MODEL,
  SCOUTING_DEVELOPMENT_STAGE
} from 'sharedKernel/constants'
import type { ScoutingSelectionFieldId, ScoutingSelectionOption } from './types'

export const SCOUTING_SELECTION_FIELD_ORDER: readonly ScoutingSelectionFieldId[] = [
  'verticalSector',
  'targetAudience',
  'businessModel',
  'developmentStage'
]

export const SCOUTING_SELECTION_CRITERION_FIELD_IDS = new Set<string>([
  ...SCOUTING_SELECTION_FIELD_ORDER
])

export const SCOUTING_OPTIONS_BY_FIELD: Record<
  ScoutingSelectionFieldId,
  ScoutingSelectionOption[]
> = {
  verticalSector: SCOUTING_VERTICAL_SECTOR,
  targetAudience: SCOUTING_TARGET_AUDIENCE,
  businessModel: SCOUTING_BUSINESS_MODEL,
  developmentStage: SCOUTING_DEVELOPMENT_STAGE
}

export const isScoutingSelectionFieldId = (id: string): id is ScoutingSelectionFieldId =>
  SCOUTING_SELECTION_CRITERION_FIELD_IDS.has(id)

export const SCOUTING_CRITERION_NAME_KEYS: Record<ScoutingSelectionFieldId, string> = {
  verticalSector: 'scouting.criterion.verticalSector',
  targetAudience: 'scouting.criterion.targetAudience',
  businessModel: 'scouting.criterion.businessModel',
  developmentStage: 'scouting.criterion.developmentStage'
}
